import React from 'react';
import { oneOfType, string, number, oneOf } from 'prop-types';
import styled from 'styled-components';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Row from '../Container/Row';
import Column from '../Container/Column';
import { CaptionText, BodyText } from '../Text/Heading';
import Image from '../Image';

import {
  MemberBlack,
  MemberGold,
  MemberPlatinum,
  MemberRed,
} from '../../utils/statics';

const MemberIcon = styled(Image)`
  width: auto;
  height: 16px;
`;

const HorizontalDivider = styled(Column)`
  height: 32px;
  width: 1px;
  border-right: 1px solid ${({ theme }) => theme.colors.greyLight};
  margin: 0 16px;
`;

const memberTypes = ['T1', 'T2', 'T3', 'T4'];
const memberIcons = {
  T1: MemberBlack,
  T2: MemberPlatinum,
  T3: MemberGold,
  T4: MemberRed,
};

const BigMember = ({ loyaltyId, loyaltyTier }) => {
  return (
    memberTypes.includes(loyaltyTier) && (
      <Row className="big-member" alignItems="center">
        <Column>
          <CaptionText className="big-member-title" lineHeight="16px">
            {translate('common.bigMemberID')}
          </CaptionText>
          <BodyText
            className="big-member-id"
            fontWeight={400}
            lineHeight="20px"
          >
            {loyaltyId}
          </BodyText>
        </Column>
        <HorizontalDivider />
        <MemberIcon
          className={`big-member-icon-${loyaltyTier}`}
          src={memberIcons[loyaltyTier]}
        />
      </Row>
    )
  );
};

BigMember.propTypes = {
  loyaltyId: oneOfType([string, number]).isRequired,
  loyaltyTier: oneOf(memberTypes).isRequired,
};

export default BigMember;
